import * as React from "react";
import { useState, useEffect } from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { FxOpenContent, FxPopupOpener } from "./../fxms/windows/FxWindows";
import { FxResource } from "./../fxms/inputs/FxResource";
import { FxWindow } from "./../fxms/windows/FxWindows";
import { FxAlarmNotify } from "./../fxms/components/FxAlarmNotify";
import { FxMoList } from "./../fxms/components/FxMoList";
import { FxInfoNoticeList } from "./../fxms/components/FxInfoNoticeList";
import { FeInfoFacMntnList } from "../fems/components/FeInfoFacMntnList";
import { FeEngValueInfo } from "../fems/components/FeEngValueInfo";
import { FeEnergyCompChart } from "../fems/components/FeEnergyCompChart";

//import "./../css/FxIconValuePanel.css";

export const VupPlantDash = (props) => {
  const planOpenRef = React.useRef(null);
  const [messageBox, setMessageBox] = useState(false);
  const [message, setMessage] = useState({});
  const [plantInlo, setPlantInfo] = useState({});
  const [inloNo, setInloNo] = useState(0);
  const [index, setIndex] = useState(0);
  let interval = null;

  useEffect(() => {
    const plantInfoJson = localStorage.getItem("plantInfoJson");
    if (plantInfoJson) {
      const obj = JSON.parse(plantInfoJson);
      setPlantInfo(obj);
      FxWindow.showNavigator(obj ? "공장 대시보드 : "       + obj.inloName : "");
    }

    if (interval === null) {
      interval = setInterval(function () {
        setIndex(index + 1);
        console.log("*** VupPlantDash *** index " + index);
      }, 5000);
    }

    return () => {
      if (interval != null) {
        clearInterval(interval);
        interval = null;
      }
      console.log("*** VupPlantDash ***  unmounted ");
      FxWindow.showNavigator("");
    };
  }, []);

  useEffect(() => {
    if (plantInlo && plantInlo.inloNo > 0) {
      console.log("*** VupPlantDash *** plantInlo : ", plantInlo);
      setInloNo(plantInlo.inloNo);
    }
  }, [plantInlo]);

  const handleClose = () => {
    setMessageBox(false);
  };

  return (
    <StyledEngineProvider injectFirst>
      <Modal open={messageBox} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            color: "black",
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2">
            {message.title}
          </Typography>
          <Typography sx={{ mt: 2 }}>{message.content}</Typography>
        </Box>
      </Modal>
      <div className={"dashWrap3"}>
        <div className="dashBtnArea">
          <div className={"mask"}>
            <div className={"slider"}>
              <FxAlarmNotify inloNo={inloNo} index={index} />
            </div>
          </div>
          <a
            className="bigBtn"
            onClick={function (e) {
              planOpenRef.current();
            }}
          >
            생산계획 입력하기
          </a>
        </div>
        <div className="dashWrapper">
          <div className="conLeft">
            <div className="radiusBox lefthigh tab">
              <ul>
                <li className="on">
                  <h2>사용량예측</h2>
                </li>
                <li>
                  <h2>에너지절감</h2>
                </li>
              </ul>
              <div className="chartArea">
                <div className="chart_container">
                  <FeEnergyCompChart engId="STEAM" src={"steam_icon001.png"} />
                </div>

                <div className="chart_container">
                  <FeEnergyCompChart engId="AIR" src={"air_icon001.png"} />
                </div>

                <div className="chart_container">
                  <FeEnergyCompChart
                    engId="COOLWATER"
                    src={"water_icon001.png"}
                  />
                </div>
              </div>
            </div>
            <FxInfoNoticeList />  {/* 공지사항 */}
          </div>

          <div className="conRight">
            <div className="numberDataArea">
              <FeEngValueInfo title="압축공기 사용량" engId="AIR" type="cons" />
              <FeEngValueInfo title="금일 제품생산량" engId="AIR" type="prod" />
            </div>
            <div className="radiusBox righthigh">
              <h2>센서현황</h2>
              <FxMoList
                inloNo={inloNo}
                index={index}
                moClass="SENSOR"
              ></FxMoList>
            </div>
            <FeInfoFacMntnList /> {/* 정비계획 */}
          </div>
        </div>
        <footer>
          <div>Virtual Utility Plant</div>
          <div>Copyright 2022 VUP All rights reserved</div>
        </footer>
      </div>
      <FxPopupOpener openRef={planOpenRef} opId="ui-0-1">
        <FxResource opId="ui-0-1" />
      </FxPopupOpener>
    </StyledEngineProvider>
  );
};
